import React from 'react'
import { Login } from '@/presentation/pages/Login'
import { makeAuthentication, makeGetUser, makeForgotPassword } from '@/main/factories/usecases'
import { NavigationPagesProps } from '@/presentation/components'

export const makeLoginFactory = (props: NavigationPagesProps): JSX.Element => {
  return (
    <Login
      {...props}
      authentication={makeAuthentication()}
      getUser={makeGetUser()}
      forgotPassword={makeForgotPassword()}
    />
  )
}
